import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { experience } from "../data/content";
import { motion } from "framer-motion";

// Compact career teaser for the home page — 3 most recent roles + link to About.
export default function CareerTeaser() {
  const roles = experience.slice(0, 3);
  return (
    <section data-testid="career-teaser" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-12">
          <div>
            <div className="overline">Career — in brief</div>
            <h2 className="font-serif text-4xl md:text-5xl mt-3 max-w-3xl" style={{ color: "var(--primary)" }}>
              Fifteen years. Five companies. Countless Gigawatts.
            </h2>
          </div>
          <Link
            to="/about"
            data-testid="career-teaser-all"
            className="text-sm inline-flex items-center gap-1 link-underline font-semibold"
            style={{ color: "var(--primary)" }}
          >
            Read full bio &amp; career <ArrowRight size={14} />
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-px" style={{ backgroundColor: "var(--border-soft)" }}>
          {roles.map((r, i) => (
            <motion.div
              key={`${r.company}-${i}`}
              className="p-7"
              style={{ backgroundColor: "var(--bg)" }}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.45, delay: i * 0.08 }}
            >
              <div className="font-mono text-[10px] font-semibold uppercase tracking-widest" style={{ color: "var(--accent-strong)" }}>
                {r.period}
              </div>
              <h3 className="mt-4 font-serif text-2xl leading-tight" style={{ color: "var(--primary)" }}>
                {r.role}
              </h3>
              <div className="mt-1 text-sm font-medium" style={{ color: "var(--accent-strong)" }}>{r.company}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
